import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AssetSummaryPreviewComponent } from './asset-summary-preview.component';

@NgModule({
  declarations: [
    AssetSummaryPreviewComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    AssetSummaryPreviewComponent
  ]
})
export class AssetSummaryPreviewModule { }
